import {
  Grid2,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tooltip,
} from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';

import bytesToSize from '@utils/bytesToSize';

const messages = defineMessages({
  remove: {
    id: 'fileDropzone.remove',
    defaultMessage: 'Remove',
  },
});

interface FileItemProps {
  file: File;
  onRemove?: (file: File) => void;
}

export const FileItem: React.FC<FileItemProps> = ({ file, onRemove }) => {
  const { formatMessage } = useIntl();

  const handleRemove = () => {
    onRemove?.(file);
  };

  return (
    <Grid2>
      <ListItem
        sx={{
          minWidth: '25px',
          border: 1,
          borderColor: 'divider',
          borderRadius: 1,
          '& + &': {
            mt: 1,
          },
        }}
      >
        <ListItemIcon>
          <Icon name="copy" size="sm" type="fas" />
        </ListItemIcon>
        <ListItemText
          primary={file.name}
          primaryTypographyProps={{
            color: 'textPrimary',
            variant: 'subtitle2',
          }}
          secondary={bytesToSize(file.size)}
        />
        <Tooltip title={<>{formatMessage(messages.remove)}</>}>
          <IconButton edge="end" onClick={handleRemove}>
            <Icon name="xmark" size="xs" type="fas" />
          </IconButton>
        </Tooltip>
      </ListItem>
    </Grid2>
  );
};
